import { type WorkspacePermission } from 'app-shared/types';

import { useCurrentWorkspace } from '@/session/hooks/useCurrentWorkspace';

// Hides or disables what the member can't do. A courtesy only: the server
// checks the same permission on every request.
export const useHasPermission = (permission: WorkspacePermission) => {
  const { currentMember } = useCurrentWorkspace();

  return currentMember.permissions.includes(permission);
};
